const n = new URL("../../../assets/icon-ronin-C_tLl46Y.svg", import.meta.url).href;
export {
  n as default
};
//# sourceMappingURL=icon-ronin.svg.js.map
